import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cakeOn from '../assets/cake-on.png';
import cakeOff from '../assets/cake-off.png';
import birthdayMusic from '../assets/wedding2music.mp3';
import birthdayBackground from '../assets/birthdaybg.png';

const Birthday2 = () => {
    const navigate = useNavigate();
    const audioRef = React.useRef(null);
    const detailsRef = React.useRef(null);

    // Doğum günü tarihi - 15 Haziran 2025 Pazar
    const [birthdayDate] = useState(new Date('2025-06-15T15:00:00'));

    // Geri sayım için state
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    const [balloons, setBalloons] = useState([]);
    const [confetti, setConfetti] = useState([]);
    const [confettiPieces, setConfettiPieces] = useState([]);
    const [isBlownOut, setIsBlownOut] = useState(false);
    const [isBalloonPopped, setIsBalloonPopped] = useState(false);
    const [balloonConfetti, setBalloonConfetti] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [recordedAudio, setRecordedAudio] = useState(null);

    const flagsData = [
        { type: 'plain', color: 'bg-blue-600' },
        { type: 'striped', color: 'bg-green-600' },
        { type: 'plain', color: 'bg-indigo-600' },
        { type: 'dotted', color: 'bg-cyan-600' },
        { type: 'plain', color: 'bg-teal-600' },
    ];

    const allFlags = Array.from({ length: 3 }).flatMap(() => flagsData);

    const popBalloon = () => {
        if (isBalloonPopped) return;

        setIsBalloonPopped(true);

        const newConfetti = [...Array(50)].map(() => ({
            id: Math.random(),
            color: ['bg-blue-500', 'bg-indigo-600', 'bg-cyan-500', 'bg-green-600'][Math.floor(Math.random() * 4)],
            angle: Math.random() * 360,
            spread: Math.random() * 90 + 60
        }));
        setBalloonConfetti(newConfetti);

        setTimeout(() => {
            setIsBalloonPopped(false);
            setBalloonConfetti([]);
        }, 2000);
    };

    const handleCakeClick = () => {
        if (!isBlownOut) {
            setIsBlownOut(true);
            // Konfeti patlaması
            const newConfetti = [...Array(60)].map(() => ({
                id: Math.random(),
                color: ['bg-blue-500', 'bg-indigo-600', 'bg-cyan-500', 'bg-green-600', 'bg-teal-600'][Math.floor(Math.random() * 5)],
                angle: Math.random() * 360,
                spread: Math.random() * 100 + 80
            }));
            setConfettiPieces(newConfetti);
            setTimeout(() => setConfettiPieces([]), 2000);

            // Pastayı sıfırla
            setTimeout(() => {
                setIsBlownOut(false);
            }, 2500);
        }
    };

    const togglePlayPause = () => {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const scrollToDetails = () => {
        detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // WhatsApp uyumlu ses formatı için codec ayarları
            let options = {};
            let fileExtension = 'm4a';

            // En uyumlu codec'leri sırasıyla dene
            if (MediaRecorder.isTypeSupported('audio/mp4; codecs="mp4a.40.2"')) {
                options = { mimeType: 'audio/mp4; codecs="mp4a.40.2"' };
                fileExtension = 'm4a';
            } else if (MediaRecorder.isTypeSupported('audio/mpeg')) {
                options = { mimeType: 'audio/mpeg' };
                fileExtension = 'mp3';
            } else if (MediaRecorder.isTypeSupported('audio/webm; codecs=opus')) {
                options = { mimeType: 'audio/webm; codecs=opus' };
                fileExtension = 'webm';
            } else if (MediaRecorder.isTypeSupported('audio/ogg; codecs=opus')) {
                options = { mimeType: 'audio/ogg; codecs=opus' };
                fileExtension = 'ogg';
            } else {
                // Son çare - varsayılan format
                options = {};
                fileExtension = 'webm';
            }

            const recorder = new MediaRecorder(stream, options);
            const chunks = [];

            // Dosya uzantısını state'e kaydet
            recorder.fileExtension = fileExtension;

            recorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    chunks.push(event.data);
                }
            };

            recorder.onstop = () => {
                // Kullanılan codec'e göre blob oluştur
                const mimeType = options.mimeType || 'audio/webm';
                const blob = new Blob(chunks, { type: mimeType });
                const url = URL.createObjectURL(blob);

                // Dosya bilgilerini kaydet
                const timestamp = new Date().getTime();
                const fileName = `ahmet-dogum-gunu-mesaj-${timestamp}.${recorder.fileExtension}`;

                // Kayıtlı ses bilgilerini state'e kaydet
                setRecordedAudio({
                    blob,
                    url,
                    fileName,
                    mimeType,
                    extension: recorder.fileExtension
                });

                // Console'da hangi format kullanıldığını göster
                console.log(`Ses kaydı tamamlandı: ${fileName}, Format: ${mimeType}`);

                // Stream'i kapat
                stream.getTracks().forEach(track => track.stop());
            };

            setMediaRecorder(recorder);
            setAudioChunks(chunks);
            recorder.start();
            setIsRecording(true);
        } catch (error) {
            console.error('Mikrofon erişimi başarısız:', error);
            alert('Mikrofon erişimi için izin vermeniz gerekiyor!');
        }
    };

    const stopRecording = () => {
        if (mediaRecorder && isRecording) {
            mediaRecorder.stop();
            setIsRecording(false);
            setMediaRecorder(null);
        }
    };

    const downloadAudio = () => {
        if (recordedAudio) {
            const a = document.createElement('a');
            a.href = recordedAudio.url;
            a.download = recordedAudio.fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };



    const clearRecording = () => {
        if (recordedAudio) {
            URL.revokeObjectURL(recordedAudio.url);
            setRecordedAudio(null);
        }
    };

    const toggleRecording = () => {
        if (isRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    };

    const handleAddToCalendar = () => {
        const formatDate = (date) => {
            return date.toISOString().replace(/-|:|\.\d\d\d/g, '');
        };

        const startTime = formatDate(birthdayDate);

        // Bitiş saati, başlangıçtan 3 saat sonrası olarak ayarlandı
        const endTime = formatDate(new Date(birthdayDate.getTime() + 3 * 60 * 60 * 1000));

        const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:Ahmet'in 15. Yaş Günü Partisi
DTSTART:${startTime}
DTEND:${endTime}
LOCATION:Cafe Paradise, Atatürk Cad. No:25 Kadıköy/İstanbul
DESCRIPTION:Ahmet'in 15. yaş günü kutlamasına davetlisiniz! Eğlence, müzik ve sürprizlerle dolu unutulmaz bir gün geçirelim!
END:VEVENT
END:VCALENDAR`;

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'ahmetin-dogum-gunu.ics';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Sayfa yüklendiğinde en üste scroll et
    useEffect(() => {
        window.scrollTo(0, 0);

        // Balonların pozisyonunu sabitle - erkek renkleri
        const generatedBalloons = [...Array(8)].map((_, i) => ({
            id: `balloon-${i}`,
            left: `${10 + Math.random() * 80}%`, // Rastgele yatay pozisyon
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${6 + Math.random() * 5}s` // Süre biraz kısıldı
        }));
        setBalloons(generatedBalloons);

        // Konfetilerin pozisyonunu ve rengini sabitle - erkek renkleri
        const confettiColors = ['bg-blue-500', 'bg-indigo-600', 'bg-cyan-500', 'bg-green-600', 'bg-teal-600', 'bg-slate-600'];
        const generatedConfetti = [...Array(15)].map((_, i) => ({
            id: `confetti-${i}`,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            animationDuration: `${8 + Math.random() * 7}s`,
            color: confettiColors[Math.floor(Math.random() * confettiColors.length)]
        }));
        setConfetti(generatedConfetti);

        // Fontları yükle
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Fredoka+One:wght@400&family=Comfortaa:wght@300;400;500;600;700&family=Pacifico&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    // Geri sayım timer'ı
    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = birthdayDate.getTime() - now;

            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                setTimeLeft({ days, hours, minutes, seconds });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [birthdayDate]);

    return (
        <div className="min-h-screen bg-white overflow-hidden relative">
            {/* Geri Dön Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-6 left-6 z-50 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-200/50"
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>
            {/* --- Bunting Banner --- */}
            <div className="absolute top-0 left-0 w-full h-24 z-30 pointer-events-none">
                <div className="w-full h-full relative">
                    {/* Rope */}
                    <div className="absolute top-8 left-0 w-full h-1 bg-slate-700"></div>
                    {/* Flags */}
                    <div className="flex justify-center w-full">
                        {allFlags.map((flag, index) => (
                            <div
                                key={index}
                                className="relative w-10 h-14 mx-2 animate-sway"
                                style={{
                                    animationDelay: `${index * 0.2}s`,
                                }}
                            >
                                <div className={`absolute top-8 w-full h-full flag-shape ${flag.color}`}>
                                    {flag.type === 'striped' && <div className="flag-stripes"></div>}
                                    {flag.type === 'dotted' && <div className="flag-dots"></div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Animasyonlu Arka Plan Elementleri */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                {/* Balonlar - Yukarı doğru uçuyor - Erkek renkleri */}
                {balloons.map((balloon, i) => (
                    <div
                        key={balloon.id}
                        className="absolute animate-float-up"
                        style={{
                            left: balloon.left,
                            bottom: '-20vh', // Ekranın altından başlıyor
                            animationDelay: balloon.animationDelay,
                            animationDuration: balloon.animationDuration
                        }}
                    >
                        <div className="relative">
                            {/* Balon - Erkek renkleri */}
                            <div
                                className={`w-8 h-10 md:w-12 md:h-16 rounded-full shadow-xl ${['bg-gradient-to-br from-blue-500 to-blue-700',
                                    'bg-gradient-to-br from-indigo-500 to-indigo-700',
                                    'bg-gradient-to-br from-green-500 to-green-700',
                                    'bg-gradient-to-br from-cyan-500 to-cyan-700',
                                    'bg-gradient-to-br from-teal-500 to-teal-700',
                                    'bg-gradient-to-br from-slate-500 to-slate-700'][i % 6]
                                    }`}
                                style={{
                                    clipPath: 'ellipse(50% 50% at 50% 40%)'
                                }}
                            ></div>
                            {/* Balon İpi */}
                            <div className="w-0.5 h-12 md:h-20 bg-gray-400 mx-auto"></div>
                        </div>
                    </div>
                ))}

                {/* Konfetiler - Daha az ve sakin */}
                {confetti.map((c) => (
                    <div
                        key={c.id}
                        className="absolute animate-fall"
                        style={{
                            left: c.left,
                            top: '-20px',
                            animationDelay: c.animationDelay,
                            animationDuration: c.animationDuration
                        }}
                    >
                        <div
                            className={`w-2 h-2 md:w-3 md:h-3 ${c.color} rounded-sm shadow-lg`}
                        ></div>
                    </div>
                ))}
            </div>

            {/* Ana İçerik */}
            <div className="relative z-10 min-h-screen flex flex-col justify-start items-center px-4 pt-28 pb-12">
                {/* Üst Kısım - İsim ve Başlık */}
                <div className="text-center mb-8 animate-fade-in">
                    {/* RİBBON HEADING */}
                    <div className="relative inline-block mb-8 animate-ribbon-wave select-none">
                        {/* Sol kurdele kuyruğu */}
                        <span className="absolute -left-3 top-1/2 -translate-y-1/2 w-0 h-0 border-y-[12px] border-r-[12px] border-y-transparent border-r-blue-400"></span>
                        {/* Sağ kurdele kuyruğu */}
                        <span className="absolute -right-3 top-1/2 -translate-y-1/2 w-0 h-0 border-y-[12px] border-l-[12px] border-y-transparent border-l-indigo-400"></span>

                        {/* Ana kurdele */}
                        <div className="px-6 py-3 bg-gradient-to-r from-blue-400 via-cyan-300 to-indigo-400 rounded-lg shadow-xl border-2 border-white/60">
                            <h2 className="text-lg md:text-xl font-extrabold text-indigo-900 tracking-wide drop-shadow-sm whitespace-nowrap">
                                🎉 DOĞUM GÜNÜ PARTİSİ 🎉
                            </h2>
                        </div>
                    </div>

                    {/* Yeni Başlık Tasarımı */}
                    <div className="flex items-center justify-center gap-2 md:gap-4 flex-wrap mb-4">
                        <h1 className="text-5xl md:text-7xl font-['Pacifico'] text-blue-600 drop-shadow-lg">
                            Ahmet
                        </h1>

                        {/* 15 Yaş Balonu */}
                        <div className="relative inline-block animate-title-float mx-2 cursor-pointer" onClick={popBalloon}>
                            {/* Konfeti Patlama Alanı */}
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none z-20">
                                {balloonConfetti.map((piece) => (
                                    <div
                                        key={piece.id}
                                        className={`absolute w-3 h-3 rounded-full ${piece.color} animate-confetti-burst`}
                                        style={{
                                            '--angle': `${piece.angle}deg`,
                                            '--spread': `${piece.spread}px`
                                        }}
                                    ></div>
                                ))}
                            </div>

                            {!isBalloonPopped ? (
                                <>
                                    <div className="w-20 h-24 md:w-24 md:h-28 bg-gradient-to-br from-indigo-500 to-indigo-700 rounded-[50%_50%_50%_50%_/_60%_60%_40%_40%] shadow-xl flex items-center justify-center transform -rotate-6">
                                        <span className="text-4xl md:text-5xl font-bold text-white font-['Fredoka_One'] drop-shadow-lg transform rotate-6">15</span>
                                    </div>
                                    {/* Balon Düğümü */}
                                    <div className="absolute bottom-[2px] left-1/2 -translate-x-1/2 w-4 h-2 bg-indigo-800 rounded-full z-10"></div>
                                    {/* Balon İpi */}
                                    <div className="absolute bottom-[-20px] left-1/2 -translate-x-1/2 w-0.5 h-8 bg-gray-400"></div>
                                </>
                            ) : (
                                <div className="relative w-20 h-24 md:w-24 md:h-28 flex items-center justify-center">
                                    {/* Patlama animasyonu için arka plan */}
                                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-indigo-700 rounded-[50%_50%_50%_50%_/_60%_60%_40%_40%] animate-pop"></div>
                                    {/* Sabit kalan sayı */}
                                    <span className="text-4xl md:text-5xl font-bold text-indigo-700 font-['Fredoka_One'] drop-shadow-lg transform rotate-6 z-10">15</span>
                                </div>
                            )}
                        </div>

                        <h1 className="text-5xl md:text-7xl font-['Pacifico'] text-blue-600 drop-shadow-lg">
                            Yaşında!
                        </h1>
                    </div>
                </div>

                {/* İnteraktif PNG Pasta */}
                <div className="mb-8 animate-slide-up relative group">
                    <div
                        className="relative w-64 h-64 md:w-80 md:h-80 cursor-pointer"
                        onClick={handleCakeClick}
                    >
                        {/* Sıcak Parıltı Efekti KALDIRILDI */}
                        <img
                            src={cakeOn}
                            alt="Birthday Cake with Candles On"
                            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ease-in-out ${isBlownOut ? 'opacity-0' : 'opacity-100'}`}
                        />

                        {/* Gerçekçi Mum Alevleri - Sadece mumlar yanıyorken */}
                        {!isBlownOut && (
                            <div className="absolute inset-0 pointer-events-none">
                                {/* Mum alevleri - pastanın üst kısmında */}
                                {[...Array(6)].map((_, i) => (
                                    <div
                                        key={i}
                                        className="absolute"
                                        style={{
                                            top: '16%',
                                            left: `${25 + i * 8.5}%`,
                                            transform: 'translate(-50%, -50%)'
                                        }}
                                    >
                                        {/* Sadece Parıltı Efekti */}
                                        <div className="flame-glow animate-flicker-glow"></div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <img
                            src={cakeOff}
                            alt="Birthday Cake with Candles Off"
                            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ease-in-out ${isBlownOut ? 'opacity-100' : 'opacity-0'}`}
                        />

                        {/* Gerçekçi Duman Efekti */}
                        <div className={`absolute inset-0 pointer-events-none ${isBlownOut ? 'show-smoke' : ''}`}>
                            <div className="smoke-wisp" style={{ top: '35%', left: '26%' }}></div>
                            <div className="smoke-wisp" style={{ top: '30%', left: '42%', animationDelay: '0.2s' }}></div>
                            <div className="smoke-wisp" style={{ top: '30%', left: '60%', animationDelay: '0.1s' }}></div>
                            <div className="smoke-wisp" style={{ top: '35%', left: '75%', animationDelay: '0.3s' }}></div>
                        </div>

                        {/* Konfeti Patlama Alanı */}
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                            {confettiPieces.map((piece) => (
                                <div
                                    key={piece.id}
                                    className={`absolute w-3 h-3 rounded-full ${piece.color} animate-confetti-burst`}
                                    style={{
                                        '--angle': `${piece.angle}deg`,
                                        '--spread': `${piece.spread}px`
                                    }}
                                ></div>
                            ))}
                        </div>

                        {/* Alev Titreşme Efekti */}
                        <div className={`absolute inset-0 pointer-events-none transition-opacity duration-300 ease-out ${!isBlownOut ? 'opacity-100' : 'opacity-0'}`}>
                            <div className="flame-anim" style={{ top: '34%', left: '26.5%', width: '16px', height: '24px' }}></div>
                            <div className="flame-anim" style={{ top: '29%', left: '42.5%', width: '16px', height: '24px', animationDelay: '0.2s' }}></div>
                            <div className="flame-anim" style={{ top: '29%', left: '59.5%', width: '16px', height: '24px', animationDelay: '0.1s' }}></div>
                            <div className="flame-anim" style={{ top: '34%', left: '74.5%', width: '16px', height: '24px', animationDelay: '0.3s' }}></div>
                        </div>
                    </div>
                </div>

                {/* Kontrol Butonları */}
                <div className="flex justify-center items-center gap-6 mb-8">
                    {/* Mum Üfleme Butonu */}
                    <button
                        onClick={handleCakeClick}
                        className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center text-2xl transform hover:scale-110 hover:shadow-xl transition-all duration-300 focus:outline-none border-2 border-blue-200 hover:border-blue-300"
                        aria-label="Mumları üfle"
                    >
                        🌬️
                    </button>

                    {/* Müzik Butonu */}
                    <button
                        onClick={togglePlayPause}
                        className={`w-20 h-20 rounded-full shadow-lg flex items-center justify-center text-3xl transform hover:scale-110 hover:shadow-xl transition-all duration-300 focus:outline-none ${isPlaying
                            ? 'bg-red-500 text-white animate-pulse border-2 border-red-300'
                            : 'bg-white text-blue-600 border-2 border-blue-300 hover:border-blue-400'
                            }`}
                        aria-label={isPlaying ? 'Müziği durdur' : 'Müziği çal'}
                    >
                        {isPlaying ? '⏸️' : '▶️'}
                    </button>

                    {/* Aşağı Kaydırma Butonu */}
                    <button
                        onClick={scrollToDetails}
                        className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center text-2xl transform hover:scale-110 hover:shadow-xl transition-all duration-300 focus:outline-none border-2 border-indigo-200 hover:border-indigo-300 animate-bounce-gentle"
                        aria-label="Detaylara git"
                    >
                        👇
                    </button>
                </div>

                {/* Geri Sayım */}
                <div className="text-center animate-slide-up" style={{ animationDelay: '0.5s' }}>
                    <h3 className="text-2xl font-bold text-gray-800 my-8 font-['Comfortaa']">
                        🎊 Pastamı Yemeye Son.. 🎊
                    </h3>

                    <div className="grid grid-cols-4 gap-4 max-w-md mx-auto">
                        <div className="bg-white/50 backdrop-blur-md rounded-xl p-4 shadow-xl border border-gray-200/50 transform hover:scale-105 transition-all duration-300">
                            <div className="text-3xl font-bold text-blue-600 font-['Fredoka_One']">{timeLeft.days}</div>
                            <div className="text-gray-700 text-sm font-medium">GÜN</div>
                        </div>
                        <div className="bg-white/50 backdrop-blur-md rounded-xl p-4 shadow-xl border border-gray-200/50 transform hover:scale-105 transition-all duration-300">
                            <div className="text-3xl font-bold text-indigo-600 font-['Fredoka_One']">{timeLeft.hours}</div>
                            <div className="text-gray-700 text-sm font-medium">SAAT</div>
                        </div>
                        <div className="bg-white/50 backdrop-blur-md rounded-xl p-4 shadow-xl border border-gray-200/50 transform hover:scale-105 transition-all duration-300">
                            <div className="text-3xl font-bold text-cyan-600 font-['Fredoka_One']">{timeLeft.minutes}</div>
                            <div className="text-gray-700 text-sm font-medium">DAKİKA</div>
                        </div>
                        <div className="bg-white/50 backdrop-blur-md rounded-xl p-4 shadow-xl border border-gray-200/50 transform hover:scale-105 transition-all duration-300">
                            <div className="text-3xl font-bold text-green-600 font-['Fredoka_One']">{timeLeft.seconds}</div>
                            <div className="text-gray-700 text-sm font-medium">SANİYE</div>
                        </div>
                    </div>
                </div>

                {/* Tarih, Konum ve Harita Kartı */}
                <div ref={detailsRef} className="w-full max-w-4xl mx-auto mt-16 animate-slide-up" style={{ animationDelay: '1s' }}>
                    <div className="bg-white/50 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-gray-200/50">
                        <div className="grid grid-cols-1">
                            {/* Bilgiler */}
                            <div className="p-8 flex flex-col justify-center">
                                <div className="flex flex-col sm:flex-row gap-8 mb-8">
                                    {/* Tarih ve Saat */}
                                    <div className="flex-1 flex items-start gap-4">
                                        <div className="bg-blue-100 text-blue-700 p-3 rounded-xl shadow-md">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-800 font-['Comfortaa']">15 Haziran 2025</h3>
                                            <p className="text-gray-600 text-lg">Pazar - 15:00</p>
                                        </div>
                                    </div>

                                    {/* Konum */}
                                    <div className="flex-1 flex items-start gap-4">
                                        <div className="bg-indigo-100 text-indigo-700 p-3 rounded-xl shadow-md">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-800 font-['Comfortaa']">Cafe Paradise</h3>
                                            <p className="text-gray-600 text-md">Atatürk Cad. No:25 Kadıköy/İstanbul</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Butonlar */}
                                <div className="flex flex-col sm:flex-row gap-4">
                                    {/* Takvime Ekle Butonu */}
                                    <button
                                        onClick={handleAddToCalendar}
                                        className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-2"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l-4-4m0 0l4-4m-4 4h12" />
                                        </svg>
                                        Takvime Ekle
                                    </button>

                                    {/* Yol Tarifi Al Butonu */}
                                    <a
                                        href="https://www.google.com/maps/dir/?api=1&destination=Cafe+Paradise,Atatürk+Caddesi,Kadıköy,İstanbul"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex-1 bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-2"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 16.382V5.618a1 1 0 00-1.447-.894L15 7m-6 3v10m6-10v10" /></svg>
                                        Yol Tarifi Al
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Sesli Mesaj Bölümü */}
                <div className="text-center mt-12 animate-slide-up" style={{ animationDelay: '1.2s' }}>
                    <h3 className="text-xl font-bold text-gray-800 mb-6 font-['Comfortaa']">
                        🎤 Ahmet'e Sesli Mesaj Bırak
                    </h3>

                    <div className="bg-white/50 backdrop-blur-md rounded-2xl p-6 shadow-xl border border-gray-200/50 max-w-md mx-auto">
                        <div className="flex flex-col items-center gap-4">
                            {/* Mikrofon Butonu */}
                            <button
                                onClick={toggleRecording}
                                disabled={recordedAudio && !isRecording}
                                className={`w-20 h-20 rounded-full shadow-xl flex items-center justify-center text-4xl text-white transform hover:scale-110 transition-all duration-300 focus:outline-none ${recordedAudio && !isRecording
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : isRecording
                                        ? 'bg-red-500 animate-pulse border-4 border-red-300'
                                        : 'bg-gradient-to-br from-blue-500 to-blue-700 border-4 border-blue-300 hover:from-blue-600 hover:to-blue-800'
                                    }`}
                                aria-label={isRecording ? 'Kaydı durdur' : 'Kayıt başlat'}
                            >
                                {isRecording ? '⏹️' : '🎤'}
                            </button>

                            {/* Durum Metni */}
                            <div className="text-center">
                                <p className={`text-lg font-semibold font-['Comfortaa'] ${recordedAudio
                                    ? 'text-blue-700'
                                    : isRecording
                                        ? 'text-red-600'
                                        : 'text-gray-700'
                                    }`}>
                                    {recordedAudio
                                        ? 'Kayıt tamamlandı! 🎉'
                                        : isRecording
                                            ? 'Kayıt alınıyor...'
                                            : 'Mikrofona bas ve konuş!'
                                    }
                                </p>
                                <p className="text-gray-500 text-sm mt-1">
                                    {recordedAudio
                                        ? 'İndir butonunu kullanarak kayıtını indirebilirsin'
                                        : isRecording
                                            ? 'Durdurmak için tekrar bas'
                                            : 'Sesli mesajını kaydet ve indir'
                                    }
                                </p>
                            </div>

                            {/* Ses Dalgası Animasyonu (sadece kayıt sırasında) */}
                            {isRecording && (
                                <div className="flex items-center justify-center gap-1">
                                    {[...Array(5)].map((_, i) => (
                                        <div
                                            key={i}
                                            className="w-1 bg-red-500 rounded-full animate-pulse"
                                            style={{
                                                height: `${Math.random() * 20 + 10}px`,
                                                animationDelay: `${i * 0.1}s`,
                                                animationDuration: '0.5s'
                                            }}
                                        ></div>
                                    ))}
                                </div>
                            )}

                            {/* İndir ve Paylaş Butonları (kayıt tamamlandıktan sonra) */}
                            {recordedAudio && (
                                <div className="flex flex-col gap-3 w-full mt-4">
                                    {/* İndir Butonu */}
                                    <button
                                        onClick={downloadAudio}
                                        className="w-full bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-2"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                                        </svg>
                                        Ses Dosyasını İndir
                                    </button>



                                    {/* Yeni Kayıt Butonu */}
                                    <button
                                        onClick={clearRecording}
                                        className="w-full bg-gradient-to-r from-gray-400 to-gray-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 text-sm"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                        </svg>
                                        Yeni Kayıt Yap
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Alt Kısım - Çağrı Metni */}
                <div className="text-center mt-12 animate-slide-up" style={{ animationDelay: '1.5s' }}>
                    <div className="bg-gray-800 text-white rounded-2xl p-6 shadow-xl max-w-md mx-auto">
                        <p className="text-lg font-medium font-['Comfortaa'] leading-relaxed">
                            🎈 Ahmet'in 15. yaş günü kutlamasına davetlisiniz! 🎈
                        </p>
                        <p className="text-gray-300 text-sm mt-2">
                            Eğlence, müzik ve sürprizlerle dolu unutulmaz bir gün geçirelim!
                        </p>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="relative bg-gradient-to-b from-gray-50 to-white mt-16 py-12">
                {/* Ana İçerik */}
                <div className="max-w-3xl mx-auto px-6 text-center">
                    {/* Teşekkür Mesajı */}
                    <div className="mb-8">
                        <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 font-['Comfortaa']">
                            Bizimle Kutlamaya Geldiğiniz İçin Teşekkürler! 🎉
                        </h3>
                        <p className="text-gray-600 text-lg leading-relaxed max-w-xl mx-auto">
                            Ahmet'in bu özel gününü daha da özel kılacak olan sizlersiniz.
                        </p>
                    </div>

                    {/* İletişim ve Hediye Bilgisi */}
                    <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 mb-8 max-w-lg mx-auto">
                        <div className="space-y-4 text-gray-700">
                            <div className="flex items-center justify-center gap-2">
                                <span className="text-blue-600">📞</span>
                                <span>Sorularınız için:</span>
                                <a href="tel:+905551234567" className="font-semibold text-blue-700 hover:underline">
                                    +90 555 123 45 67
                                </a>
                            </div>
                            <div className="flex items-center justify-center gap-2">
                                <span className="text-indigo-600">🎁</span>
                                <span>Bizim için  <strong>en büyük hediye</strong> sizin gelmenizdir.</span>
                            </div>
                        </div>
                    </div>

                    {/* Alt Bilgi */}
                    <div className="pt-6 border-t border-gray-200">
                        <p className="text-gray-500 text-sm mb-3">
                            💖 Sevgiyle hazırlanmıştır • 2025
                        </p>
                        <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg">
                            <span className="text-sm font-medium">DigiVite ile tasarlandı</span>
                        </div>
                    </div>
                </div>
            </footer>

            <audio ref={audioRef} src={birthdayMusic} loop />

            {/* CSS Animasyonları */}
            <style jsx>{`
                @keyframes float-up {
                    0% {
                        transform: translateY(0);
                        opacity: 1;
                    }
                    60% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-120vh);
                        opacity: 0;
                    }
                }
                
                @keyframes flicker-glow {
                    0%, 100% { 
                        box-shadow: 0 0 12px 6px rgba(255, 180, 50, 0.55), 0 0 20px 9px rgba(255, 120, 0, 0.45);
                        opacity: 0.9;
                    }
                    50% { 
                        box-shadow: 0 0 14px 7px rgba(255, 190, 60, 0.65), 0 0 24px 11px rgba(255, 130, 0, 0.55);
                        opacity: 1;
                    }
                }
                
                @keyframes smoke-rise {
                    0% {
                        transform: translateY(0) scale(0.8);
                        opacity: 0;
                    }
                    20% {
                        opacity: 0.7;
                    }
                    100% {
                        transform: translateY(-40px) scale(0);
                        opacity: 0;
                    }
                }
                
                @keyframes fall {
                    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
                    100% { transform: translateY(110vh) rotate(360deg); opacity: 1; }
                }
                
                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                
                @keyframes fade-in {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                @keyframes slide-up {
                    from { opacity: 0; transform: translateY(50px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                @keyframes ribbon-wave {
                    0%, 100% {
                        transform: rotate(-1deg);
                    }
                    50% {
                        transform: rotate(1deg);
                    }
                }

                /* Başlık Balon Animasyonu */
                @keyframes title-float {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-12px);
                    }
                }
                .animate-title-float {
                    animation: title-float 4s ease-in-out infinite;
                }
                
                /* Balon Patlama ve Konfeti Animasyonları */
                @keyframes pop {
                    0% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.3);
                        opacity: 0.5;
                    }
                    100% {
                        transform: scale(0);
                        opacity: 0;
                    }
                }
                .animate-pop {
                    animation: pop 0.4s ease-out forwards;
                }

                @keyframes confetti-burst {
                    0% {
                        transform: translate(0, 0) rotate(0deg) scale(1);
                        opacity: 1;
                    }
                    100% {
                        transform: translate(calc(cos(var(--angle)) * var(--spread)), calc(sin(var(--angle)) * var(--spread))) rotate(360deg) scale(0);
                        opacity: 0;
                    }
                }
                .animate-confetti-burst {
                    animation: confetti-burst 1.5s ease-out forwards;
                }

                /* Yumuşak bounce animasyonu */
                @keyframes bounce-gentle {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-8px);
                    }
                }
                .animate-bounce-gentle {
                    animation: bounce-gentle 2s ease-in-out infinite;
                }

                .animate-ribbon-wave {
                    animation: ribbon-wave 6s ease-in-out infinite;
                }
                
                .animate-float-up {
                    animation: float-up infinite linear;
                }
                
                .smoke-wisp {
                    position: absolute;
                    width: 12px;
                    height: 12px;
                    background: rgba(210, 210, 210, 0.6);
                    border-radius: 50%;
                    opacity: 0;
                    filter: blur(6px);
                    transform-origin: center;
                }
                
                .show-smoke .smoke-wisp {
                    animation: smoke-rise 2.2s ease-out forwards;
                }
                
                .animate-fall {
                    animation: fall infinite linear;
                }
                
                .animate-spin-slow {
                    animation: spin-slow 3s linear infinite;
                }
                
                .animate-fade-in {
                    animation: fade-in 1s ease-out;
                }
                
                .animate-slide-up {
                    animation: slide-up 1s ease-out;
                }

                .flame-glow {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    animation: flicker-glow 2.5s ease-in-out infinite;
                }

                .flag-shape {
                    clip-path: polygon(0 0, 100% 0, 50% 100%);
                }
                .flag-stripes {
                    width: 100%;
                    height: 100%;
                    background: repeating-linear-gradient(
                        -45deg,
                        transparent,
                        transparent 4px,
                        #3B82F6 4px, /* blue-500 */
                        #3B82F6 8px
                    );
                }
                .flag-dots {
                    width: 100%;
                    height: 100%;
                    background-image: radial-gradient(#3B82F6 25%, transparent 25%);
                    background-size: 12px 12px;
                    background-position: 0 0, 6px 6px;
                }

                @keyframes sway {
                    0%, 100% { transform: rotate(4deg); }
                    50% { transform: rotate(-4deg); }
                }
                .animate-sway {
                    transform-origin: top center;
                    animation: sway 4s linear infinite alternate;
                }

                /* Footer Animasyonları */
                @keyframes twinkle {
                    0%, 100% { 
                        opacity: 0.3; 
                        transform: scale(0.8) rotate(0deg);
                    }
                    50% { 
                        opacity: 1; 
                        transform: scale(1.2) rotate(180deg);
                    }
                }
                .animate-twinkle {
                    animation: twinkle 4s ease-in-out infinite;
                }
                
                .animate-fall {
                    animation: fall infinite linear;
                }
            `}</style>
        </div>
    );
};

export default Birthday2;